import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { useSessionStore } from "@/modules/session/store";
import { storeToRefs } from "pinia";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: () =>
      import(
        /* webpackChunkName: "main-layout" */ "@/layouts/main-layout/main-layout.vue"
      ),
    children: [
      {
        path: "",
        name: "start",
        meta: {
          requiresAuth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/cabinet/views/start.vue"
          ),
      },
      {
        path: "/materials",
        name: "materials",
        meta: {
          requiresAuth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "materials" */ "@/views/cabinet/views/materials.vue"
          ),
      },
      {
        path: "/favorite",
        name: "favorite",
        meta: {
          requiresAuth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "favorite" */ "@/views/cabinet/views/favorite.vue"
          ),
      },
      {
        path: "/content/:id",
        name: "content",
        meta: {
          requiresAuth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "video" */ "@/views/cabinet/views/content.vue"
          ),
      },
      {
        path: "/lesson/:id",
        name: "lesson",
        meta: {
          requiresAuth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "video" */ "@/views/cabinet/views/lesson.vue"
          ),
      },
      {
        path: "/settings",
        name: "settings",
        meta: {
          requiresAuth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "settings" */ "@/views/cabinet/views/settings.vue"
          ),
      },
    ],
  },
  {
    path: "/feedback",
    name: "feedback",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "feedback" */ "@/views/cabinet/views/feedback.vue"
      ),
  },
  {
    path: "/login/:code?",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/auth/login/login.vue"),
  },
  {
    path: "/success",
    name: "success",
    component: () =>
      import(/* webpackChunkName: "success" */ "@/views/success.vue"),
  },
  {
    path: "/damon-baker-privacy-policy",
    name: "damon-baker-privacy-policy",
    meta: {
      requiresAuth: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "settings" */ "@/views/cabinet/views/damon-baker-privacy-policy.vue"
      ),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to) {
    const element = document.querySelector(".main-layout-content");
    if (element) {
      element.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  },
  routes,
});

router.beforeEach(async (to, from, next) => {
  const sessionStore = useSessionStore();
  const { state } = storeToRefs(sessionStore);

  try {
    await sessionStore.getUser();

    const isUserAuth = state?.value?.user?.user?.email;

    if (isUserAuth && to.name === "login") {
      next("/");
    } else if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (isUserAuth) {
        next();
      } else {
        next("/login");
      }
    } else {
      next();
    }
  } catch (error) {
    console.error("An error occurred:", error);
    next("/error");
  }
});

export default router;
